(function($){
	$.validator.methods.email = function(value, element) {
	    return value.trim().length === 0 || /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value);
	};
})($);
